export default "__VITE_ASSET__CZ9um9YL__"